function canUseWebP() {
    var elem = document.createElement('canvas');
    if (!!(elem.getContext && elem.getContext('2d'))) {
        // was able or not to get WebP representation
        return elem.toDataURL('image/webp').indexOf('data:image/webp') == 0;
    }
    // very old browser like IE 8, canvas not supported
    return false;
}

let webpSupport = canUseWebP();

export function scaleImg(url, width?, height?) {
    if (url.includes('res.cloudinary.com/mytidy')) {
        let parts = url.split(/(upload\/)/);

        // change to webp
        let last_parts = parts[parts.length - 1].split('.');
        let format = webpSupport ? 'webp' : 'jpg';
        last_parts[last_parts.length - 1] = format;
        parts[parts.length - 1] = last_parts.join('.');

        // scale
        if (width && height) {
            let scale_string = `c_fit,w_${width},h_${height},q_75/`;
            return parts[0] + parts[1] + scale_string + parts[2];
        }
        else
            return parts[0] + parts[1] + parts[2];
    }
    else {
        return url;
    }
}

export function restoreOriginalImg(url: string): string {
    if (url.includes('res.cloudinary.com/mytidy')) {
        let parts = url.split(/(upload\/)/);

        if (parts.length < 3) {
            return url; // Se il formato non è quello atteso, restituisci l'URL originale
        }

        // Rimuove i parametri di trasformazione (esempio: "c_fit,w_XXX,h_XXX,q_75/")
        let processedPart = parts[2].replace(/^c_fit,w_\d+,h_\d+,q_75\//, '');

        // Ripristina il formato originale (jpg o altro)
        let last_parts = processedPart.split('.');
        if (last_parts.length > 1) {
            last_parts[last_parts.length - 1] = 'jpg'; // Assumiamo che il formato originale fosse JPG
        }

        return parts[0] + parts[1] + last_parts.join('.');
    }

    return url; // Se non è un URL Cloudinary, restituiscilo così com'è
}

export function aspectRatioImgGoogle(url) {
    if (url.includes('res.cloudinary.com/mytidy')) {
        let parts = url.split(/(upload\/)/);

        // change to webp
        let last_parts = parts[parts.length - 1].split('.');
        let format = webpSupport ? 'webp' : 'jpg';
        last_parts[last_parts.length - 1] = format;
        parts[parts.length - 1] = last_parts.join('.');

        return [
            parts[0] + parts[1] + `ar_16:9,c_crop/` + parts[2],
            parts[0] + parts[1] + `ar_4:3,c_crop/` + parts[2],
            parts[0] + parts[1] + `ar_1:1,c_crop/` + parts[2],
        ]
    }
    else {
        return url ? [url] : [];
    }
}